import { Pipe, PipeTransform } from '@angular/core';
import { OverrideService } from '../../@shelter/utils/override.service';

@Pipe({
  name: 'localized'
})
export class LocalizedPipe implements PipeTransform {

  constructor(private override:OverrideService) { } 
  transform(value: unknown, ...args: unknown[]): unknown {
    return value? value[this.override.currentLang]:'';
  }

}
